import clsx from "clsx";
import { PropsWithChildren, useMemo } from "react";

import { useContextApp } from "@/screens/app/context/app";

import { useStyles } from "./viewport.css";

export const Viewport = ({ children }: PropsWithChildren<{}>) => {
  const {
    state: { isExpanded },
  } = useContextApp();

  const classes = useStyles();

  return useMemo(
    () => (
      <div
        className={clsx(classes.viewport, {
          [classes["viewport--expanded"]]: isExpanded,
        })}
      >
        {children}
      </div>
    ),
    [children, classes, isExpanded],
  );
};
